module.exports = __webpack_public_path__ + "static/media/booking_successful.39b81e96.svg";